/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContactTag } from './SourceContactTag';
import {
    SourceContactTagFromJSON,
    SourceContactTagFromJSONTyped,
    SourceContactTagToJSON,
    SourceContactTagToJSONTyped,
} from './SourceContactTag';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
    SourceToJSONTyped,
} from './Source';

/**
 * 
 * @export
 * @interface SourceContact
 */
export interface SourceContact {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    source_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    phone_number?: string | null;
    /**
     * 
     */
    position?: string;
    /**
     * 
     */
    primary_contact: boolean;
    /**
     * 
     */
    tag_id?: string | null;
    /**
     * 
     */
    tag?: SourceContactTag;
    /**
     * 
     */
    source?: Source;
}

/**
 * Check if a given object implements the SourceContact interface.
 */
export function instanceOfSourceContact(value: object): value is SourceContact {
    if (!('source_id' in value) || value['source_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('primary_contact' in value) || value['primary_contact'] === undefined) return false;
    return true;
}

export function SourceContactFromJSON(json: any): SourceContact {
    return SourceContactFromJSONTyped(json, false);
}

export function SourceContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'source_id': json['source_id'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone_number': json['phone_number'] === undefined ? undefined : json['phone_number'] === null ? null : json['phone_number'],
        'position': json['position'] == null ? undefined : json['position'],
        'primary_contact': json['primary_contact'],
        'tag_id': json['tag_id'] === undefined ? undefined : json['tag_id'] === null ? null : json['tag_id'],
        'tag': json['tag'] == null ? undefined : SourceContactTagFromJSON(json['tag']),
        'source': json['source'] == null ? undefined : SourceFromJSON(json['source']),
    };
}

export function SourceContactToJSON(json: any): SourceContact {
    return SourceContactToJSONTyped(json, false);
}

export function SourceContactToJSONTyped(value?: SourceContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'source_id': value['source_id'],
        'name': value['name'],
        'email': value['email'],
        'phone_number': value['phone_number'],
        'position': value['position'],
        'primary_contact': value['primary_contact'],
        'tag_id': value['tag_id'],
        'tag': SourceContactTagToJSON(value['tag']),
        'source': SourceToJSON(value['source']),
    };
}

